<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-9.5,787.95l10-2.73l10,2.73v9.09l-10,2.73l-10-2.73V787.95z M1.41,787.05h-1.82v5.45h1.82V787.05z M2.32,788.34v2.13
	c0.55,0.5,0.91,1.21,0.91,2.03c0,1.52-1.21,2.73-2.73,2.73c-1.52,0-2.73-1.21-2.73-2.73c0-0.81,0.35-1.53,0.91-2.02v-2.13
	c-1.6,0.71-2.73,2.3-2.73,4.16c0,2.5,2.05,4.55,4.55,4.55c2.5,0,4.54-2.05,4.54-4.55C5.05,790.64,3.92,789.05,2.32,788.34z"/>
</svg>

</template>